module.exports = __webpack_public_path__ + "img/link-banner-en.e0082ceb.png";